import memoize from 'transmute/memoize';

/**
 * @description Given a raw html string, evaluate the content
 * to determine if there are valid iframe elements with src attributes.
 * This can be used to determine if html should be rendered
 * for the sake of iframe content.
 */

export const hasIframeContent = memoize(html => {
  if (!html) return false;
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const iframes = doc.querySelectorAll('iframe');
  if (iframes.length === 0) return false;
  return Array.from(iframes).some(iframe => {
    const src = iframe.getAttribute('src');
    return src && src.trim().length > 0;
  });
});